// TODO надо подумать на счёт того, чтобы объединить все листенеры в один
// и регистрировать блоки, для которых нужно проводить отслеживание скролла
export default {
  data () {
    return {
      blockViewActionProcessed: false,
    }
  },

  methods: {
    /**
     * @description Если нет processBlockView обработчика, то не вешаем листенер
     * @return {boolean}
     */
    hasProcessBlockView () {
      return typeof this.processBlockView === 'function'
    },

    checkIfBlockIsVisible (event, isSecondCheck) {
      if (this.blockViewActionProcessed) {
        window.removeEventListener('scroll', this.checkIfBlockIsVisible)
        return
      }
      const windowHeight = window.innerHeight
      const scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop
      const blockOffsetTop = this.$el.offsetTop
      const blockOffsetHeight = this.$el.offsetHeight

      // [scrollTop; scrollTop + windowHeight] видимая часть
      // [blockOffsetTop; blockOffsetTop + blockOffsetHeight] - часть блока

      const noIntersection = blockOffsetTop > scrollTop + windowHeight || blockOffsetTop + blockOffsetHeight < scrollTop

      if (!noIntersection) {
        const intersectionL = Math.max(scrollTop, blockOffsetTop)
        const intersectionR = Math.min(scrollTop + windowHeight, blockOffsetTop + blockOffsetHeight)

        const percentage = (intersectionR - intersectionL) / blockOffsetHeight

        if (percentage >= 0.6) {
          if (isSecondCheck) {
            this.processBlockView()
            this.blockViewActionProcessed = true
          } else {
            setTimeout(() => {
              this.checkIfBlockIsVisible(event, true)
            }, 3000)
          }
        }
      }
    },
  },

  mounted () {
    if (this.hasProcessBlockView()) {
      // console.log('Component name:', this.$options.name)
      window.addEventListener('scroll', this.checkIfBlockIsVisible)
      this.checkIfBlockIsVisible()
    }
  },

  beforeUnmount () {
    if (this.hasProcessBlockView()) {
      window.removeEventListener('scroll', this.checkIfBlockIsVisible)
    }
  },
}
